// extracted by mini-css-extract-plugin
module.exports = {"unit":"var(--ring-unit)","content":"Permalinks__content--ub"};